import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ro from './ro';
import en from './en';
import { loadVisitorLanguage } from './visitorLanguage';

i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language === 'ro' ? 'ro' : 'en';
});

// Resolve once before mounting React to avoid showing the wrong language first.
// Old i18nextLng values were automatically forced to Romanian, so ignore them.
export const i18nReady = loadVisitorLanguage().then((language) =>
  i18n.use(initReactI18next).init({
    resources: {
      ro: { translation: ro },
      en: { translation: en },
    },
    supportedLngs: ['ro', 'en'],
    fallbackLng: 'en',
    lng: language,
    interpolation: {
      escapeValue: false, // React already escapes
    },
  }),
);

export default i18n;
